﻿import * as React from "react";
import { IFrameCommManager, PointerEventsManager } from "../Managers";
import { PointerEventsProperty } from "csstype";

export interface IToolFrameProps {
    displayName: string;
    iteration?: number;
    moduleID: number;
    toolLookup: string;
    toolUrl: string;
}

export interface IToolFrameState {
    cover: "visible" | "hidden";
    pointerEvents: boolean;
}

export class ToolFrame extends React.Component<
    IToolFrameProps,
    IToolFrameState
> {
    constructor(props: IToolFrameProps) {
        super(props);

        IFrameCommManager.registerOrUpdateToolFrame(this.postMessage);

        this.state = {
            cover: `visible`,
            pointerEvents: true,
        };
    }

    componentDidMount(): void {
        PointerEventsManager.registerWatcher(`ToolFrame`, this._pointerEvents);
        window.addEventListener(`message`, this._messageListener);
        window.addEventListener(`message`, this._warningListener);
    }

    componentWillUnmount(): void {
        PointerEventsManager.deRegisterWatcher(`ToolFrame`);
        IFrameCommManager.deRegisterToolFrame();
        window.removeEventListener(`message`, this._messageListener);
        window.removeEventListener(`message`, this._warningListener);
    }

    private _frameRef: HTMLIFrameElement;

    private _lastIteration: number;

    private readonly _onFrameLoad = (): void => {
        // Register user activity inside the iframe to avoid adding it to every tool individually.
        // We don't want to bubble the entire event as that could trigger other unintended events.
        if (this.props.toolUrl.startsWith(`/Applications/`)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._frameRef.contentWindow.addEventListener(
                `mousemove`,
                (window as any).__AUTH_UPDATE,
            );
        }
        this.setState({
            cover: `hidden`,
        });
    };

    public postMessage = (message: string): void => {
        this._frameRef.contentWindow.postMessage(message, `*`);
    };

    private readonly _messageListener = (message: MessageEvent): void => {
        IFrameCommManager.messageListener(this.props.moduleID, message);
    };

    private readonly _warningListener = (message: MessageEvent): void => {
        if (typeof message.data === `string`) {
            if (message.data === `Warning:Account`) {
                // Then navigate to the login page.
                window.location.href = `${window.location.origin}/Account/Login`;
            } else if (message.data === `Warning:SmartTools`) {
                // Then navigate the frame to the 500 error page.
                this._frameRef.src = `${window.location.origin}/ErrorPages/500.html`;
            }
        }
    };

    private readonly _pointerEvents = (pointerEvents: boolean): void => {
        this.setState({
            pointerEvents,
        });
    };

    render(): React.ReactElement {
        if (this.props.iteration !== this._lastIteration) {
            this._lastIteration = this.props.iteration;
            // TODO remove the eslint disable and fix the lint
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state = {
                cover: `visible`,
                pointerEvents: true,
            };
        }

        // Disable pointer events when told to. This makes dragging elements much smoother.
        const pointerSetting: PointerEventsProperty = !this.state.pointerEvents
            ? `none`
            : `auto`;

        return (
            <div
                className={`root-toolframe`}
                style={{
                    pointerEvents: pointerSetting,
                }}
            >
                <div className={`toolframe-cover ${this.state.cover}`}>
                    <div className={`cover-centercontainer`}>
                        <img src={`/Images/LoadingAnimation.svg`} />
                    </div>
                </div>
                {/* the key on the iframe is used to force react to create a new one for every new iteration of the toolframe element. */}
                <iframe
                    className={`toolframe-frame`}
                    key={this._lastIteration}
                    onLoad={this._onFrameLoad}
                    ref={(f): HTMLIFrameElement => (this._frameRef = f)}
                    src={this.props.toolUrl}
                />
            </div>
        );
    }
}
